export const COMMENT_DAMAGE_RANK_CODES = ['A0', 'A1', 'B0', 'B', 'C', 'D'] as const;
export type CommentDamageRank = typeof COMMENT_DAMAGE_RANK_CODES[number];

// 検索専用。判定を持つ付箋のうち判定が空欄のものを指す
export const COMMENT_DAMAGE_RANK_SEARCH_NONE = 'none';
export type CommentDamageRankSearch = CommentDamageRank | typeof COMMENT_DAMAGE_RANK_SEARCH_NONE;

export const COMMENT_DAMAGE_RANK_SEARCH_OPTIONS: { value: CommentDamageRankSearch; label: string }[] = [
  ...COMMENT_DAMAGE_RANK_CODES.map(code => ({ value: code, label: code })),
  { value: COMMENT_DAMAGE_RANK_SEARCH_NONE, label: 'なし' },
];
